import { render, staticRenderFns } from "./ObjectBreadcrumbsButton.vue?vue&type=template&id=18c29fc6&scoped=true&"
import script from "./ObjectBreadcrumbsButton.vue?vue&type=script&lang=ts&"
export * from "./ObjectBreadcrumbsButton.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectBreadcrumbsButton.vue?vue&type=style&index=0&id=18c29fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c29fc6",
  null
  
)

export default component.exports